// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.UP-container[data-v-7059efcf] {\n  margin-right: 1rem;\n}\n.nom-convive[data-v-7059efcf] {\n  margin-left: 48px;\n  margin-top: -9px;\n  font-size: 0.8rem;\n  font-style: italic;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
